import { render, staticRenderFns } from "./register-case-warnings.vue?vue&type=template&id=e5f2fac8&scoped=true&"
import script from "./register-case-warnings.vue?vue&type=script&lang=ts&"
export * from "./register-case-warnings.vue?vue&type=script&lang=ts&"
import style0 from "./register-case-warnings.vue?vue&type=style&index=0&id=e5f2fac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f2fac8",
  null
  
)

export default component.exports